import React from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Notification from "./Notification/Notification";
import "./NotificationOffcanvas/NotificationOffcanvas.css"

const NotificationModal = ({ show, onHide }) => {
  return (
    <Offcanvas 
      show={show} 
      onHide={onHide} 
      placement="end" /* Slides out from the right side */
      className="notification-offcanvas"
    >
      <Offcanvas.Header closeButton className="notification-offcanvas__header">
        <Offcanvas.Title className="notification-offcanvas__title">
          Notifications
        </Offcanvas.Title>
      </Offcanvas.Header>
      
      <Offcanvas.Body className="notification-offcanvas__body">
        {/* Keeps your notification list component working seamlessly */}
        <Notification show={show} />
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default NotificationModal;